module.exports = __webpack_public_path__ + "img/pikachu.6cc7b065.gif";